import { useSyncExternalStore } from "react";

// Single source of truth for the mobile/desktop split (Tailwind's md breakpoint).
// Used ONLY by the app shell and surface selectors; leaf components stay presentation-pure.
const QUERY = "(max-width: 767px)";

const subscribe = (cb) => {
  const m = window.matchMedia(QUERY);
  m.addEventListener("change", cb);
  return () => m.removeEventListener("change", cb);
};

export const useIsMobile = () =>
  useSyncExternalStore(subscribe, () => window.matchMedia(QUERY).matches, () => false);
